import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomButton from "../../Components/Common/CustomButton";
import InputText from "../../Components/sectioninput/formelement/InputText";
import { handleError } from "../../REDUX/actions/notifications";
import { addUser } from "../../REDUX/actions/users";

const NewUserView = () => {
  const dispatch = useDispatch();

  const [formData, setuserForm] = useState({});

  const [passwordConfirmation, setpasswordConfirmation] = useState("");
  const [isAdmin, setisAdmin] = useState(false);
  const disableForm = !formData.username || !formData.lastName || !formData.firstName || !formData.email || !formData.password || !passwordConfirmation;

  const handleChangeForm = (value, champs) => {
    setuserForm({ ...formData, [champs]: value });
  };

  const handleChangePass = (value) => {
    setpasswordConfirmation(value);
  };

  const handleIsAdmin = (e) => {
    setisAdmin(e);
  };

  const handleUpdateCredentials = () => {
    if (passwordConfirmation !== formData.password) {
      dispatch(handleError("Different passwords", 1));
      // eslint-disable-next-line
    } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(formData.email)) {
      dispatch(handleError("Invalid email address", 1));
    } else {
      dispatch(addUser({ ...formData, isAdmin: isAdmin }));
    }
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center gap-5">
        <div className="col-6 bg-white rounded-10 shadowed p-5">
          <h2 className="mb-0 f24 fw-normal text-start mb-5">User Information</h2>
          <InputText labelinput="Username" handleChange={handleChangeForm} value={formData.username} champs="username" flag={false} hideIfEmpty={false} />
          <InputText labelinput="Last Name" handleChange={handleChangeForm} value={formData.lastName} champs="lastName" flag={false} hideIfEmpty={false} />
          <InputText labelinput="First Name" handleChange={handleChangeForm} value={formData.firstName} champs="firstName" flag={false} hideIfEmpty={false} />
          <div className="text-start my-2">
            <label className="f16 text-start mb-1">Role</label>
            <Form.Select defaultValue={false} className="customSelect rounded-3" aria-label="Default select example mb-2" onChange={(e) => handleIsAdmin(e.target[1].selected)}>
              <option value={false}>Editor</option>
              <option value={true}>Administrator</option>
            </Form.Select>
          </div>
          <div className="mt-5"></div>
        </div>

        <div className="col-5 bg-white rounded-10 shadowed p-5">
          <h2 className="mb-0 f24 fw-normal text-start mb-5">Login Credentials</h2>

          <InputText labelinput="E-mail" handleChange={handleChangeForm} value={formData.email} champs="email" flag={false} hideIfEmpty={false} />

          <InputText labelinput="Password" type="password" handleChange={handleChangeForm} champs="password" flag={false} hideIfEmpty={false} />
          <InputText labelinput="Confirm New Password" type="password" handleChange={handleChangePass} champs="password" flag={false} hideIfEmpty={false} />
          <div className="mt-5">
            <CustomButton buttonText="Add user" iconStart={"pencil"} disabled={disableForm} callBack={handleUpdateCredentials} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUserView;
